import React from 'react';
import {Load} from './style';
// import { Container } from './styles';

function Loading() {
  return (
    <Load>
      
    </Load>
  );
}

export default Loading;
